
import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    if (error.message && error.message.includes('ResizeObserver loop')) {
      // Prevent the error from being reported
      this.setState({ hasError: false });
    }
  }

  render() {
    return this.props.children;
  }
}

export default ErrorBoundary;